/* eslint-disable @typescript-eslint/naming-convention */
import { IOrderApiModel, ORDER_STATUS, ProductOrderDetail } from '../repositories/IStore.api';

export class OrderModel implements OrderModelProps {
  id: string;
  refundedAmount: number;
  subtotal: number;
  subtotalWithoutTax: number;
  total: number;
  totalWithoutTax: number;
  giftCardRedemption: number;
  totalBeforeGiftCardRedemption: number;
  giftCardDoubleSpending: boolean;
  email: string;
  tax: number;
  b2b_b2c: string;
  ipAddress: string;
  couponDiscount: number;
  paymentStatus: string;
  fulfillmentStatus: string;
  orderNumber: number;
  vendorOrderNumber: string;
  refererUrl: string;
  volumeDiscount: number;
  customerId: number;
  membershipBasedDiscount: number;
  totalAndMembershipBasedDiscount: number;
  customSurcharges: any[];
  discount: number;
  usdTotal: number;
  globalReferer: string;
  createDate: string;
  updateDate: string;
  createTimestamp: number;
  updateTimestamp: number;
  items: ProductOrderDetail[];
  refunds: any[];
  billingPerson: {
    name: string;
    firstName: string;
    lastName: string;
    street: string;
    city: string;
  };
  handlingFee: {
    value: number;
    valueWithoutTax: number;
    taxes: any[];
  };
  predictedPackage: any[];
  shipments: any[];
  shippingOption: any;
  shippingPerson: any;
  additionalInfo: any;
  contact: any;
  paymentParams: any;
  hidden: boolean;
  taxesOnShipping: any[];
  acceptMarketing: boolean;
  disableAllCustomerNotifications: boolean;
  externalFulfillment: boolean;
  invoices: any[];
  pricesIncludeTax: boolean;







  // buyerEmail: string;
  // buyerName: string;
  // id: number;
  // price: number;
  // resourceUri: string;
  // sessionId: string;
  // shipToAddress: string;
  // shipToCity: string;
  // shipToCountry: string;
  // shipToPostalCode: string;
  // shipToState?: any;
  // shippingCost?: any;
  // shippingId: string;
  // shippingName: string;
  // siteId: number;
  // status: ORDER_STATUS;
  // timestamp: string;
  // transactionId?: any;
  // whitelabelId: number;

  constructor(data: OrderModelProps) {
    this.id = data.id;
    this.refundedAmount = data.refundedAmount;
    this.subtotal = data.subtotal;
    this.subtotalWithoutTax = data.subtotalWithoutTax;
    this.total = data.total;
    this.totalWithoutTax = data.totalWithoutTax;
    this.giftCardRedemption = data.giftCardRedemption;
    this.totalBeforeGiftCardRedemption = data.totalBeforeGiftCardRedemption;
    this.giftCardDoubleSpending = data.giftCardDoubleSpending;
    this.email = data.email;
    this.tax = data.tax;
    this.b2b_b2c = data.b2b_b2c;
    this.ipAddress = data.ipAddress;
    this.couponDiscount = data.couponDiscount;
    this.paymentStatus = data.paymentStatus;
    this.fulfillmentStatus = data.fulfillmentStatus;
    this.orderNumber = data.orderNumber;
    this.vendorOrderNumber = data.vendorOrderNumber;
    this.refererUrl = data.refererUrl;
    this.volumeDiscount = data.volumeDiscount;
    this.customerId = data.customerId;
    this.membershipBasedDiscount = data.membershipBasedDiscount;
    this.totalAndMembershipBasedDiscount = data.totalAndMembershipBasedDiscount;
    this.customSurcharges = data.customSurcharges;
    this.discount = data.discount;
    this.usdTotal = data.usdTotal;
    this.globalReferer = data.globalReferer;
    this.createDate = data.createDate;
    this.updateDate = data.updateDate;
    this.createTimestamp = data.createTimestamp;
    this.updateTimestamp = data.updateTimestamp;
    this.items = data.items;
    this.refunds = data.refunds;

    this.billingPerson = data.billingPerson;
      // this.billingPerson.name = data.billingPerson.name;
      // this.billingPerson.firstName = data.billingPerson.firstName;
      // this.billingPerson.lastName = data.billingPerson.lastName;
      // this.billingPerson.street = data.billingPerson.street;
      // this.billingPerson.city = data.billingPerson.city;

    this.handlingFee = data.handlingFee;
      // this.handlingFee.value = data.handlingFee.value;
      // this.handlingFee.valueWithoutTax = data.handlingFee.valueWithoutTax;
      // this.handlingFee.taxes = data.handlingFee.taxes;

    this.predictedPackage = data.predictedPackage;
    this.shipments = data.shipments;
    this.additionalInfo = data.additionalInfo;
    this.contact = data.contact;
    this.paymentParams = data.paymentParams;
    this.hidden = data.hidden;
    this.taxesOnShipping = data.taxesOnShipping;
    this.acceptMarketing = data.acceptMarketing;
    this.disableAllCustomerNotifications = data.disableAllCustomerNotifications;
    this.externalFulfillment = data.externalFulfillment;

    this.invoices = data.invoices;
    this.pricesIncludeTax = data.pricesIncludeTax;
  }

  static fromApi(data: IOrderApiModel) {
    return ({
      id : data.id,
      refundedAmount : data.refundedAmount,
      subtotal : data.subtotal,
      subtotalWithoutTax : data.subtotalWithoutTax,
      total : data.total,
      totalWithoutTax : data.totalWithoutTax,
      giftCardRedemption : data.giftCardRedemption,
      totalBeforeGiftCardRedemption : data.totalBeforeGiftCardRedemption,
      giftCardDoubleSpending : data.giftCardDoubleSpending,
      email : data.email,
      tax : data.tax,
      b2b_b2c : data.b2b_b2c,
      ipAddress : data.ipAddress,
      couponDiscount : data.couponDiscount,
      paymentStatus : data.paymentStatus,
      fulfillmentStatus : data.fulfillmentStatus,
      orderNumber : data.orderNumber,
      vendorOrderNumber : data.vendorOrderNumber,
      refererUrl : data.refererUrl,
      volumeDiscount : data.volumeDiscount,
      customerId : data.customerId,
      membershipBasedDiscount : data.membershipBasedDiscount,
      totalAndMembershipBasedDiscount : data.totalAndMembershipBasedDiscount,
      customSurcharges : data.customSurcharges,
      discount : data.discount,
      usdTotal : data.usdTotal,
      globalReferer : data.globalReferer,
      createDate : data.createDate,
      updateDate : data.updateDate,
      createTimestamp : data.createTimestamp,
      updateTimestamp : data.updateTimestamp,
      items : data.items,
      refunds : data.refunds,

      billingPerson : data.billingPerson,

      handlingFee : data.handlingFee,

      predictedPackage : data.predictedPackage,
      shipments : data.shipments,
      shippingPerson: (data.shippingPerson !== undefined) ? data.shippingPerson : null,
      shippingOption: (data.shippingOption !== undefined) ? data.shippingOption : null,
      additionalInfo : data.additionalInfo,
      contact : data.contact,
      paymentParams : data.paymentParams,
      hidden : data.hidden,
      taxesOnShipping : data.taxesOnShipping,
      acceptMarketing : data.acceptMarketing,
      disableAllCustomerNotifications : data.disableAllCustomerNotifications,
      externalFulfillment : data.externalFulfillment,

      invoices : data.invoices,
      pricesIncludeTax : data.pricesIncludeTax,
    });
  }

  static empty() {
    return new OrderModel({
      id: null,
      refundedAmount: null,
      subtotal: null,
      subtotalWithoutTax: null,
      total: null,
      totalWithoutTax: null,
      giftCardRedemption: null,
      totalBeforeGiftCardRedemption: null,
      giftCardDoubleSpending: null,
      email: null,
      tax: null,
      b2b_b2c: null,
      ipAddress: null,
      couponDiscount: null,
      paymentStatus: null,
      fulfillmentStatus: null,
      orderNumber: null,
      vendorOrderNumber: null,
      refererUrl: null,
      volumeDiscount: null,
      customerId: null,
      membershipBasedDiscount: null,
      totalAndMembershipBasedDiscount: null,
      customSurcharges: null,
      discount: null,
      usdTotal: null,
      globalReferer: null,
      createDate: null,
      updateDate: null,
      createTimestamp: null,
      updateTimestamp: null,
      items: null,
      refunds: null,

      billingPerson: null,
      handlingFee: null,
      predictedPackage: null,
      shipments: null,
      additionalInfo: null,
      contact: null,
      paymentParams: null,
      hidden: null,
      taxesOnShipping: null,
      acceptMarketing: null,
      disableAllCustomerNotifications: null,
      externalFulfillment: null,

      invoices: null,
      pricesIncludeTax: null,
    });
  }
}

export interface OrderModelProps {
  id: string;
  refundedAmount: number;
  subtotal: number;
  subtotalWithoutTax: number;
  total: number;
  totalWithoutTax: number;
  giftCardRedemption: number;
  totalBeforeGiftCardRedemption: number;
  giftCardDoubleSpending: boolean;
  email: string;
  tax: number;
  b2b_b2c: string;
  ipAddress: string;
  couponDiscount: number;
  paymentStatus: string;
  fulfillmentStatus: string;
  orderNumber: number;
  vendorOrderNumber: string;
  refererUrl: string;
  volumeDiscount: number;
  customerId: number;
  membershipBasedDiscount: number;
  totalAndMembershipBasedDiscount: number;
  customSurcharges: any[];
  discount: number;
  usdTotal: number;
  globalReferer: string;
  createDate: string;
  updateDate: string;
  createTimestamp: number;
  updateTimestamp: number;
  items: ProductOrderDetail[];
  refunds: any[];
  billingPerson: {
    name: string;
    firstName: string;
    lastName: string;
    street: string;
    city: string;
  };
  handlingFee: {
    value: number;
    valueWithoutTax: number;
    taxes: any[];
  };
  predictedPackage: any[];
  shipments: any[];
  additionalInfo: any;
  contact?: any;
  paymentParams: any;
  hidden: boolean;
  taxesOnShipping: any[];
  acceptMarketing: boolean;
  disableAllCustomerNotifications: boolean;
  externalFulfillment: boolean;
  invoices: any[];
  pricesIncludeTax: boolean;
}

